import { Box, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { PartListColId } from 'elements/components/PartList/enums';
import { IComponentTemplate } from 'elements/types';

export const CostCell = (props: ICellRendererParams<IComponentTemplate>) => {
  const data = getAgGridTableCellData(props, PartListColId.COMPUTED_COST);

  const { computedCost, computedPurchaseCost } = data || {};

  if (!computedPurchaseCost && !computedCost) {
    return <Box sx={{ textAlign: 'right' }}>{props?.value || DEFAULT_PLACEHOLDER}</Box>;
  }

  return (
    <Stack>
      <Price amount={computedCost || 0} label={`${t('labelStandardCost')}:`} />
      <Price amount={computedPurchaseCost || 0} label={`${t('labelCost')}:`} />
    </Stack>
  );
};
